export type IProjectViewerColorTemplateField =
  | "type.name"
  | "name"
  | "instanceClass"
  | "system"
  | "compCode"
  | "discipline";

type IProjectViewerColorTemplateItem = {
  name?: string | null;
  typeName?: string | null;
  instanceClass?: string | null;
  system?: string | null;
  compCode?: string | null;
  discipline?: string | null;
};

type IProjectViewerColorTemplateMatcher =
  | {
      kind: "fieldEquals";
      field: IProjectViewerColorTemplateField;
      value: string;
    }
  | {
      kind: "fieldIncludes";
      field: IProjectViewerColorTemplateField;
      value: string;
    }
  | {
      kind: "fieldRegex";
      field: IProjectViewerColorTemplateField;
      pattern: string;
      flags?: string;
    };

export type IProjectViewerColorTemplateRule = {
  id: string;
  color: string;
  label: string;
  description?: string;
  matcher: IProjectViewerColorTemplateMatcher;
};

type IProjectViewerColorTemplate = readonly IProjectViewerColorTemplateRule[];

export const COLOR_TEMPLATES = {
  jording: [
    {
      id: "jording-conduit-with-fittings",
      color: "#9c36b5",
      label: "Jordning",
      matcher: {
        kind: "fieldEquals",
        field: "type.name",
        value: "Conduit with Fittings:Jording",
      },
    },
    {
      id: "jording-apparatfundament",
      color: "#e03131",
      label: "Apparatfundament",
      matcher: {
        kind: "fieldRegex",
        field: "type.name",
        pattern: "^Apparatfundament",
      },
    },
  ],
} as const satisfies Record<string, IProjectViewerColorTemplate>;

export type IProjectViewerColorTemplateName = keyof typeof COLOR_TEMPLATES;

export const getProjectViewerColorTemplateRules = (
  templateName: IProjectViewerColorTemplateName
): readonly IProjectViewerColorTemplateRule[] => COLOR_TEMPLATES[templateName];

const getProjectViewerColorTemplateFieldValue = (
  item: IProjectViewerColorTemplateItem,
  field: IProjectViewerColorTemplateField
): string | null => {
  switch (field) {
    case "type.name":
      return item.typeName?.trim() || null;
    case "name":
      return item.name?.trim() || null;
    case "instanceClass":
      return item.instanceClass?.trim() || null;
    case "system":
      return item.system?.trim() || null;
    case "compCode":
      return item.compCode?.trim() || null;
    case "discipline":
      return item.discipline?.trim() || null;
    default: {
      const _exhaustive = field;
      return _exhaustive;
    }
  }
};

const matchesProjectViewerColorTemplateRule = (
  rule: IProjectViewerColorTemplateRule,
  item: IProjectViewerColorTemplateItem
): boolean => {
  const value = getProjectViewerColorTemplateFieldValue(item, rule.matcher.field);
  if (!value) return false;

  switch (rule.matcher.kind) {
    case "fieldEquals":
      return value === rule.matcher.value;
    case "fieldIncludes":
      return value.includes(rule.matcher.value);
    case "fieldRegex":
      return new RegExp(rule.matcher.pattern, rule.matcher.flags).test(value);
    default: {
      const _exhaustive = rule.matcher;
      return _exhaustive;
    }
  }
};

export const getProjectViewerColorTemplateItemRule = (
  templateName: IProjectViewerColorTemplateName,
  item: IProjectViewerColorTemplateItem
): IProjectViewerColorTemplateRule | undefined =>
  COLOR_TEMPLATES[templateName].find((rule) => matchesProjectViewerColorTemplateRule(rule, item));

export const getProjectViewerColorTemplateItemColor = (
  templateName: IProjectViewerColorTemplateName,
  item: IProjectViewerColorTemplateItem
): string | undefined => getProjectViewerColorTemplateItemRule(templateName, item)?.color;
